import "../phaser.min.js";
import Common from "../Includes/Common.js";

class Ui extends Phaser.Scene {
    constructor() {
        super('Ui');
        this.common = new Common();
        this.pausedScenes = [];

    }

    init(data){
        this.soundOn = true;
    }

    preload() {
        this.load.image('logo', this.common.assetsPath + 'sprites/white-knockout.png')
        this.load.atlas('ui', this.common.assetsPath + 'sprites/ui-master.png', this.common.assetsPath + 'sprites/ui-master_atlas.json');
    }

    create() {

        const buttonY = this.scale.height / 12;

        //background
        this.scene.bringToTop();
        let homeButton = this.add.sprite(this.scale.width / 12 * 10.25, buttonY, 'ui', 'home-button').setOrigin(0.5).setScale(this.common.gameScale)
        homeButton.setInteractive({cursor: 'pointer'});
        homeButton.on('pointerdown', () => {
            window.location.href = 'https://www.streetsmartar.org/';
        })
        homeButton.on('pointerover', () => {
            this.tweens.add({
                targets: homeButton,
                scale: 4.2,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        })
        homeButton.on('pointerout', () => {
            this.tweens.add({
                targets: homeButton,
                scale: 4,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        })


        this.soundButton = this.add.sprite(this.scale.width / 12 * 11, buttonY, 'ui', 'sound-button').setOrigin(0.5).setScale(this.common.gameScale)
        this.soundButton.setInteractive({cursor: 'pointer'});
        this.soundButton.on('pointerdown', () => {
            this.soundOn = !this.soundOn;
            if(!this.soundOn)
                this.soundButton.setTexture('ui', 'mute-button')
            else
                this.soundButton.setTexture('ui', 'sound-button')
            this.sound.setMute( !this.soundOn)
            this.events.emit('soundSettingChange', {soundOn: this.soundOn});
        })
        this.soundButton.on('pointerover', () => {
            this.tweens.add({
                targets: this.soundButton,
                scale: 4.2,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        })
        this.soundButton.on('pointerout', () => {
            this.tweens.add({
                targets: this.soundButton,
                scale: 4,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        })


        let helpButton = this.add.sprite(this.scale.width / 12, this.scale.height / 12 * 11, 'ui', 'help-button').setOrigin(0.5).setScale(this.common.gameScale)
        this.add.sprite(this.scale.width / 12, buttonY, 'logo')
                .setOrigin(0.5)

        helpButton.setInteractive({cursor: 'pointer'})
        helpButton.on('pointerdown', () => {

            if(this.modal.visible){
                this.events.emit('hiding-help-modal')
                this.pausedScenes.forEach(scene => {
                    if (scene !== this) {
                        scene.scene.resume();
                    }
                });
            }else{
                this.events.emit('showing-help-modal')
                this.pausedScenes = [];
                let activeScenes = this.scene.manager.getScenes(true);
                activeScenes.forEach(scene => {
                    // Prevent the current scene from pausing itself
                    if (scene !== this) {
                        this.pausedScenes.push(scene);
                        scene.scene.pause();
                    }
                });
            }

            this.modal.setVisible(!this.modal.visible)
            this.modalCloseButton.setVisible(!this.modalCloseButton.visible)
            this.modalHeading.setVisible(!this.modalHeading.visible)
            let textChildren = this.modalText.getChildren();
            for(var i = 0; i < textChildren.length; i++) {
                textChildren[i].setVisible(!textChildren[i].visible);
            }
            this.modalOverlay.setVisible(!this.modalOverlay.visible)
        })
        helpButton.on('pointerover', () => {
            this.tweens.add({
                targets: helpButton,
                scale: 4.2,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        })
        helpButton.on('pointerout', () => {
            this.tweens.add({
                targets: helpButton,
                scale: 4,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        })

        this.modalOverlay = this.add.rectangle(0, 0, this.scale.width, this.scale.height, '#555553')
                .setScale(this.common.gameScale)
                .setAlpha(0.8)
                .setVisible(false);

        this.modal = this.add.image(0, 0, 'ui', 'dropdown-flat')
                .setOrigin(0, 0)
                .setScale(this.common.gameScale)
                .setVisible(false);
        this.modalCloseButton = this.add.image(this.scale.width / 12 * 10.25, this.scale.height / 12 * 2, 'ui', 'close-normal')
                .setOrigin(0.5)
                .setScale(this.common.gameScale)
                .setVisible(false)
                .setInteractive({cursor: 'pointer'})
        this.modalHeading = this.add.text(
                this.scale.width / 2,
                this.scale.height / 12 * 2.5,
                'How to Play',
                {
                        fontFamily: this.common.font, fontSize: 96, color: '#333',
                        textAlign: 'center',
                        wordWrap: {
                            width: this.modal.width * 4 - 800,
                            useAdvancedWrap: true,
                        }
                    }).setOrigin(0.5).setVisible(false)

        const list = [
                '1. Select your school district, name and car.',
                '2. Answer the questions as best as you can.',
                '3. If you guess wrong, no worries, just try again!',
                '4. Don\'t forget to view your results to go back and learn.',
                '5. Check out the leaderboard to see if you\'re on it!',
        ]

        this.modalText = this.add.group();

        for(let i = 0; i < list.length; i++) {
            this.modalText.add(this.add.text(
                    this.scale.width / 2 - 575,
                    this.scale.height / 24 * (8 + (2 * i)),
                    list[i],
                    {
                        fontFamily: this.common.font, fontSize: 60, color: '#333',
                        textAlign: 'left',
                        wordWrap: {
                            width: this.modal.width * 4 - 500,
                            useAdvancedWrap: true,
                        }
                    }
            ).setOrigin(0, 0.5)).setVisible(false)
        }


        this.modalCloseButton.on('pointerover', () => {
            this.modalCloseButton.setTexture('ui', 'close-hover')
        })

        this.modalCloseButton.on('pointerout', () => {
            this.modalCloseButton.setTexture('ui', 'close-normal')
        })

        this.modalCloseButton.on('pointerdown', () => {
            this.events.emit('hiding-help-modal')
            this.modal.setVisible(false);
            this.modalCloseButton.setVisible(false);
            this.modalHeading.setVisible(false)
            this.modalOverlay.setVisible(false)
            let textChildren = this.modalText.getChildren();
            for(var i = 0; i < textChildren.length; i++) {
                textChildren[i].setVisible(false);
            }
            this.pausedScenes.forEach(scene => {
                if (scene !== this) {
                    scene.scene.resume();
                }
            });
        })
    }
}

export default Ui;